import { ApiService } from "pwapi";

import {
  FLAG_CREATE_FAILURE,
  FLAG_CREATE_REQUEST,
  FLAG_CREATE_SUCCESS,
} from "./constants";
import { AsyncSagaAction, createAsyncSaga } from "../utils/asyncActions";

type FlagOptions = Parameters<typeof ApiService.createSlideFlag>[0] & {
  isMislabel?: boolean;
};
export const createFlag: AsyncSagaAction<FlagOptions> = createAsyncSaga(
  FLAG_CREATE_REQUEST,
  FLAG_CREATE_SUCCESS,
  FLAG_CREATE_FAILURE,
  ({ parentLookupSlideId }) => `/api/slides/${parentLookupSlideId}/flags/`,
  ApiService.createSlideFlag
);
